import { render } from "./DrListPopPage.vue?vue&type=template&id=92b12af8&scoped=true"
import script from "./DrListPopPage.vue?vue&type=script&lang=js"
export * from "./DrListPopPage.vue?vue&type=script&lang=js"

import "./DrListPopPage.vue?vue&type=style&index=0&id=92b12af8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92b12af8"]])

export default __exports__